import { render, staticRenderFns } from "./searchKeyWords.vue?vue&type=template&id=a53a7680&scoped=true"
import script from "./searchKeyWords.vue?vue&type=script&lang=js"
export * from "./searchKeyWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53a7680",
  null
  
)

export default component.exports